import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/language/LanguageContext';
import { aboutData } from '../../utils/aboutData';
import './About.css';

const About = () => {
    const { language } = useLanguage();
    const location = useLocation();
    const [activeSection, setActiveSection] = useState('pali');
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const section = location.pathname.split('/').pop();
        if (section && section !== 'about') {
            setIsAnimating(true);
            setActiveSection(section);
            setTimeout(() => setIsAnimating(false), 500);
        }
    }, [location]);

    const data = aboutData[language];

    const handleSectionClick = (sectionId) => {
        if (sectionId !== activeSection) {
            setIsAnimating(true);
            setActiveSection(sectionId);
            setTimeout(() => setIsAnimating(false), 500);
        }
    };

    return (
        <div className="maha-about-page">
            <div className="maha-about-hero">
                <div className="maha-hero-overlay"></div>
                <h1 className="maha-hero-title">Mahãvihãra</h1>
            </div>

            <div className="maha-about-container">
                <div className="maha-nav-sidebar">
                    {data.sections.map((section) => (
                        <button
                            key={section.id}
                            className={`maha-nav-item ${activeSection === section.id ? 'active' : ''}`}
                            onClick={() => handleSectionClick(section.id)}
                        >
                            {section.title}
                        </button>
                    ))}
                </div>

                <div className="maha-content-section">
                    {data.sections.map((section) => (
                        <div
                            key={section.id}
                            className={`maha-content-block ${
                                activeSection === section.id ? 'active' : ''
                            } ${isAnimating ? 'animating' : ''}`}
                        >
                            <h2 className="maha-section-title">{section.title}</h2>
                            {section.content.map((paragraph, index) => (
                                <p key={index} className="maha-paragraph">
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default About;